export const VALIDATION_PARAMS = {
  camera: {
    minFPS: 15,
    minWidth: 480,
    minHeight: 640,
    minScreenSize: 4, // polegadas
    minRefreshRate: 60, // Hz
    requireFrontCamera: true,
    requireColorCamera: true,
    blockVirtualCamera: true
  },
  lighting: {
    minBrightness: 50, // 0-255
    maxBrightness: 200,
    targetBrightness: 125
  },
  network: {
    minBandwidth: 500, // kbps
    testFileSize: 1024 * 100, // 100KB
    maxTestTime: 10000 // 10 segundos
  }
}; 